import type { ProductLogoMediumProps } from '../types';

/**
 * 中サイズのContractorCoreロゴアイコン
 */
export function ProductLogoMediumContractorCore({
  size = 40,
  ...props
}: ProductLogoMediumProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 40 40"
      fill="none"
      {...props}
    >
      <rect width="40" height="40" rx="5.88235" fill="#1A2142" />
      <path
        d="M21.9997 20.3415C21.9997 20.1041 21.8229 19.9017 21.5858 19.8897C21.4891 19.8847 21.3917 19.8823 21.2938 19.8823H14.2349C11.1162 19.8823 8.58789 22.4105 8.58789 25.5293V27.647C8.58789 28.0368 8.90393 28.3528 9.29377 28.3528H21.5291C21.789 28.3528 21.9997 28.1422 21.9997 27.8823V20.3415Z"
        fill="white"
      />
      <path
        d="M24.0407 20.5942C23.7492 20.4316 23.4114 20.6572 23.4114 20.9909V27.8823C23.4114 28.1422 23.6221 28.3528 23.882 28.3528H25.2938C25.0339 28.3528 24.8232 28.1422 24.8232 27.8823V27.4117C24.8232 27.1518 25.0339 26.9411 25.2938 26.9411H26.4702C26.7301 26.9411 26.9408 26.7304 26.9408 26.4705V25.9999C26.9408 25.74 26.7301 25.5293 26.4702 25.5293H25.2938C25.0339 25.5293 24.8232 25.3186 24.8232 25.0587V24.5881C24.8232 24.3282 25.0339 24.1175 25.2938 24.1175H26.1559C26.4634 24.1175 26.6885 23.8268 26.5801 23.539C26.5032 23.3347 26.4147 23.1361 26.3156 22.9439C26.2385 22.7946 26.0819 22.7058 25.9139 22.7058H25.2938C25.0339 22.7058 24.8232 22.4951 24.8232 22.2352V21.7646C24.8232 21.5136 24.8824 21.1618 24.6817 21.011C24.4783 20.8582 24.2641 20.7188 24.0407 20.5942Z"
        fill="white"
      />
      <path
        d="M22.7055 13.5293C22.7055 16.2582 20.4933 18.4705 17.7644 18.4705C15.0354 18.4705 12.8232 16.2582 12.8232 13.5293C12.8232 10.8004 15.0354 8.58813 17.7644 8.58813C20.4933 8.58813 22.7055 10.8004 22.7055 13.5293Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M28.7661 17.7646C28.9533 17.7646 29.1328 17.839 29.2652 17.9714L31.6753 20.3814C31.8076 20.5138 31.882 20.6933 31.882 20.8805V29.7646C31.882 30.1545 31.566 30.4705 31.1761 30.4705H24.1173C23.7275 30.4705 23.4114 30.1545 23.4114 29.7646V18.4705C23.4114 18.0806 23.7275 17.7646 24.1173 17.7646H28.7661ZM24.8232 21.7646C24.8232 21.5047 25.0339 21.294 25.2938 21.294H29.9997C30.2596 21.294 30.4702 21.5047 30.4702 21.7646V22.2352C30.4702 22.4951 30.2596 22.7058 29.9997 22.7058H25.2938C25.0339 22.7058 24.8232 22.4951 24.8232 22.2352V21.7646ZM25.2938 24.1175C25.0339 24.1175 24.8232 24.3282 24.8232 24.5881V25.0587C24.8232 25.3186 25.0339 25.5293 25.2938 25.5293H29.9997C30.2596 25.5293 30.4702 25.3186 30.4702 25.0587V24.5881C30.4702 24.3282 30.2596 24.1175 29.9997 24.1175H25.2938ZM25.2938 26.9411C25.0339 26.9411 24.8232 27.1518 24.8232 27.4117V27.8823C24.8232 28.1422 25.0339 28.3528 25.2938 28.3528H29.9997C30.2596 28.3528 30.4702 28.1422 30.4702 27.8823V27.4117C30.4702 27.1518 30.2596 26.9411 29.9997 26.9411H25.2938Z"
        fill="#57D7D9"
      />
      <path
        d="M31.6812 20.3873C31.7553 20.4614 31.7028 20.5881 31.598 20.5881H29.5291C29.2692 20.5881 29.0585 20.3774 29.0585 20.1175V18.0486C29.0585 17.9438 29.1852 17.8913 29.2593 17.9654L31.6812 20.3873Z"
        fill="white"
      />
    </svg>
  );
}
